import { ProductTypeObject } from '../product-type-object.model';
import { isNullOrUndefined } from 'util';
import { TabObject } from './tab-object.model';

export class ItemObject {

    public url: string;

    constructor(public map: number, public productId: string,
        public type: ProductTypeObject, public tab: TabObject) {
        if (isNullOrUndefined(this.type.urlPath)) {
            this.url = null;
        } else {
            this.url = `provision/products/detail`;
        }
    }

    public static create() {
        return new ItemObject(null, null, ProductTypeObject.UNKNOWN, TabObject.GENERAL_TAB);
    }

    public static createWithTabAndType(map: number, productId: string, tab: string, type: string) {
        return new ItemObject(map, productId, this.getType(type), TabObject.createWithName(tab));
    }

    private static getType(type: string): ProductTypeObject {
        switch (type) {
            case ProductTypeObject.PRODUCT.urlPath:
                return ProductTypeObject.PRODUCT;
            case ProductTypeObject.CFS.urlPath:
                return ProductTypeObject.CFS;
            case ProductTypeObject.RFS.urlPath:
                return ProductTypeObject.RFS;
            default: return ProductTypeObject.PRODUCT;
        }
    }

    public clone() {
        return new ItemObject(this.map, this.productId, this.type, this.tab);
    }

}